import React from "react";
import {
  Card,
  Form,
  Input,
  Button,
  Checkbox,
  Alert,
  Image,
  message,
  Row,
  Col,
  Modal,
  notification,
} from "antd";
import { connect } from "react-redux";
import { professionalAction, userActions } from "../../_actions";
import "./LoginPage.css";
import { Carousel } from "antd";
import { slide1_1, slide1_2, slide1_3, bg1_1 } from "./sliders/slider";
import { UserOutlined, LockOutlined, PhoneOutlined } from "@ant-design/icons";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import ReCAPTCHA from "react-google-recaptcha";
import "./../../responsive.css";
import axios from "axios";
const TEST_SITE_KEY = process.env.REACT_APP_SITE_KEY;
const DELAY = 1500;

const contentStyle = {
  height: "80vh",
  color: "#fff",
  lineHeight: "100vh",
  textAlign: "center",
  background: "#364967",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};
class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    // reset login status
    this.props.dispatch(userActions.logout());
    this.onFinish = this.onFinish.bind(this);
    this.onFinishFailed = this.onFinishFailed.bind(this);
    const { loggedIn, error } = this.props;
    this.state = {
      loggedIn: loggedIn,
      // error: error,
      callback: "not fired",
      value: "[empty]",
      load: false,
      expired: "false",
      recaptchavalidate: false,
      recaptchaLoaded: false,
      ipAddress: "",
      isChecked: false,
      userid: "",
      password: "",
      phone: "",
    };
    this._reCaptchaRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    console.log("this.props.loggedIn", this.props.loggedIn, this.props.error);
    if (
      this.props.loggedIn == false &&
      (this.props.error == "Bad Request" || this.props.error == "") &&
      prevProps.loggedIn != this.props.loggedIn
    ) {
      this.setState({
        showError: true,
        errorMessage: "Invalid Credentials!",
      });
      setTimeout(() => {
        this.setState({ showError: false });
      }, 5000);
      // notification.config({
      //   zIndex: 200000,
      // });
      //  notification.error({
      //   //  message: "Login Error",
      //    description: "Invalid Credentials!",
      //    placement: "topRight",
      //    duration: 5,
      //    className: notification,
      //  });
      // message.error("User that you've entered is incorrect!!");
      // message.error("Invalid Credentials!");
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ load: true });
    }, DELAY);
    this.getData();

    if (localStorage.checkbox && localStorage.email !== "") {
      this.setState({
        isChecked: true,
        userid: localStorage.userid,
        phone: localStorage.phone,
        password: localStorage.password,
      });
    }
  }

  asyncScriptOnLoad = () => {
    this.setState({ callback: "called!", recaptchaLoaded: true });
  };

  onSubmitAsync = () => {
    this._reCaptchaRef.current.executeAsync().then((value) => {});
  };

  async getData() {
    const res = await axios.get(
      `${process.env.REACT_APP_GEOLOCATION_URL}/json/`
    );
    this.setState({ ipAddress: res.data.IPv4 });
  }

  onFinish = async (values) => {
    const { dispatch } = this.props;
    if (this.state.value == "[empty]") {
      this.setState({ recaptchavalidate: true });
      return;
    }
    if (values.userid && values.password) {
      const hashedPassword = base64_encode(values.password);
      localStorage.userid = values.userid;
      localStorage.phone = values.phone;
      localStorage.password = values.password;
      localStorage.checkbox = values.remember ? "1" : "";

      const loginResponse = await dispatch(
        userActions.login(
          values.userid,
          hashedPassword,
          values.phone,
          this.state.ipAddress,
          this.state.value
        )
      );
      console.log("loginResponse", loginResponse);
      this._reCaptchaRef.current.reset();
    }
    console.log("this.props", this.props);

    const { loggedIn, error } = this.props;
    this.setState({
      loggedIn: loggedIn,
      error: error,
    });
    const cityId = localStorage.getItem("cityId");

    // if (cityId) this.getVerificationAndAppUsers();
  };

  getVerificationAndAppUsers = async () => {
    try {
      const cityId = localStorage.getItem("cityId");
      if (!cityId || cityId === "0") {
        console.log("No valid cityId found, skipping API calls.");
        localStorage.setItem("allocatedVerification", "");
        localStorage.setItem("appUsers", "[]");
        return;
      }

      const verificationResponse = await professionalAction.getVerificationAllocation(
        cityId
      );
      if (!verificationResponse.ok) {
        throw new Error(
          `Error fetching verification allocation: ${verificationResponse.statusText}`
        );
      }
      const verificationText = await verificationResponse.text();
      const module = JSON.parse(verificationText);

      localStorage.setItem(
        "allocatedVerification",
        JSON.stringify(module?.data[0])
      );

      if (module?.data[0]?.plan === "Plan C") {
        const appUsersResponse = await professionalAction.getAppUsers(cityId);
        if (!appUsersResponse.ok) {
          throw new Error(
            `Error fetching app users: ${appUsersResponse.statusText}`
          );
        }
        const appUsersText = await appUsersResponse.text();
        const appUsers = JSON.parse(appUsersText);

        localStorage.setItem("appUsers", JSON.stringify(appUsers.data));
      }
    } catch (err) {
      console.error("API Error:", err.message);
    }
  };

  onFinishFailed = (errorInfo) => {};

  handleChange = (value) => {
    this.setState({ value });
    this.setState({ recaptchavalidate: false });
    if (value === null) this.setState({ expired: "true" });
  };

  onChangeCheckbox = (event) => {
    this.setState({
      isChecked: event.target.checked,
    });
  };

  render() {
    const {
      value,
      callback,
      load,
      expired,
      recaptchaLoaded,
      recaptchavalidate,
      ipAddress,
    } = this.state || {};
    return (
      <>
        <Modal
          width="100%"
          title=""
          open={this.props.isModalVisible}
          onOk={this.props.handleModalClose} // Close modal on OK
          onCancel={this.props.handleModalClose}
          footer={null}
          className="loginModal"
          centered
        >
          {this.state.showError && (
            <div className="custome-message">{this.state.errorMessage}</div>
          )}
          <div
            className="login-wrap"
            style={{
              backgroundImage: `url(${bg1_1})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "left top",
              backgroundColor: "#384e7",
            }}
          >
            {/* <Row>
            <Col span={4} style={{ backgroundColor: "" }}></Col>

            <Col span={4} style={{ backgroundColor: "#" }}></Col>

            <Col span={6}></Col>
            <Col
              span={8}
              style={{ backgroundColor: "#eae8e8", color: "black" ,width:"100%"}}
            >
              <div className="login-heading-wrap">
                <h1 className="login-heading">CMIS</h1>
                <h4 className="login-subheading">
                  CRIMINAL MONITORING INTELLIGENT SYSTEM
                </h4>
              </div>
            </Col>
          </Row> */}
            <Col span={24}>
              <Row>
                <Col md={12}>
                  {/* <div className="video-wrap">
              <video width="320" height="240" controls loop={true} >
                  <source src={WEBSITE_1} type="video/mp4" />

                </video>
              </div> */}
                  <div className="leftLine"></div>
                  <div className="crousel" style={{ marginTop: "60px" }}>
                    <Carousel effect="fade" autoplay>
                      <div>
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <h3
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignContent: "center",
                            color: "#fff",
                          }}
                        >
                          Criminal Monitoring Intelligent System (CMIS)
                        </h3>
                      </div>
                      <div>
                        <div style={{ textAlign: "center", color: "#fff" }}>
                          <b>Concept</b>
                          <br />
                          <br />
                          <p>
                            This application can be used to a large extent to
                            monitor the accused who are committing crimes
                            against goods as well as to reduce the crime ratio.
                          </p>
                          <p>
                            To curb the accused / Criminal with two or more
                            offenses by taking preventive action and monitoring
                            them from time to time.
                          </p>
                          <p>
                            To take appropriate preventive action in case of
                            fresh charges against property offenders.
                          </p>
                          <p>
                            Surveillance of accused who repeatedly commit crimes
                            against goods using location tracking.
                          </p>
                        </div>
                      </div>
                      <div>
                        <div style={{ textAlign: "center", color: "#fff" }}>
                          <b>Use of Application</b>
                          <br />
                          <br />
                          <p>
                            {" "}
                            The Beat Amaldar of Police Thane was aware of the
                            criminals on the record in his area, which helped
                            him to check the criminals and monitor their
                            movements.
                          </p>
                          <p>
                            The fact that the offenders on the record are
                            constantly visited at their place of residence helps
                            them to be held accountable by the police and
                            prevent them if they have any other plans
                          </p>
                          <p>
                            Obtaining up-to-date photos of criminals about
                            goods.
                          </p>
                          <p>
                            It was easily possible to keep up-to-date records of
                            the accused who committed crimes against goods.
                          </p>
                          <p>
                            Immediate detection of offenders by way of criminal
                            proceedings (MOB).
                          </p>
                        </div>
                      </div>
                    </Carousel>
                  </div>
                </Col>
                <Col md={12} style={{ backgroundColor: "#eae8e8" }}>
                  <div className="login-heading-wrap">
                    <h1 className="login-heading">CMIS</h1>
                    <h4 className="login-subheading">
                      CRIMINAL MONITORING INTELLIGENT SYSTEM
                    </h4>
                  </div>
                  <Card className="loginCard" bordered={false}>
                    <Form
                      name="basic"
                      initialValues={{
                        remember: true,
                        userid: this.state.userid,
                        phone: this.state.phone,
                        password: this.state.password,
                      }}
                      onFinish={this.onFinish}
                      onFinishFailed={this.onFinishFailed}
                    >
                      <Form.Item
                        name="userid"
                        defaultValue="Bob"
                        rules={[
                          {
                            required: true,
                            message: "Please input your userid!",
                          },
                        ]}
                      >
                        <Input
                          prefix={
                            <UserOutlined
                              className="site-form-item-icon"
                              style={{ color: "#26395c" }}
                            />
                          }
                          placeholder="UserId"
                        />
                      </Form.Item>
                      <Form.Item
                        name="phone"
                        rules={[
                          {
                            required: true,
                            message: "Please input your Mobile Number!",
                          },
                        ]}
                      >
                        <Input
                          prefix={
                            <PhoneOutlined
                              className="site-form-item-icon"
                              style={{ color: "#26395c" }}
                            />
                          }
                          placeholder="Mobile Number"
                        />
                      </Form.Item>
                      <Form.Item
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: "Please input your password!",
                          },
                        ]}
                      >
                        <Input.Password
                          prefix={
                            <LockOutlined
                              className="site-form-item-icon"
                              style={{ color: "#26395c" }}
                            />
                          }
                          placeholder="Password"
                        />
                      </Form.Item>

                      <Form.Item
                        className="rememberMeCheckbox"
                        name="remember"
                        valuePropName="checked"
                        onChange={this.onChangeCheckbox}
                      >
                        <Checkbox>
                          <span style={{ color: "#26395c" }}>Remember me</span>
                        </Checkbox>
                      </Form.Item>
                      {load && (
                        <>
                          <div className="recaptcha_div">
                            <ReCAPTCHA
                              style={{ display: "inline-block" }}
                              ref={this._reCaptchaRef}
                              sitekey={TEST_SITE_KEY}
                              onChange={this.handleChange}
                              asyncScriptOnLoad={this.asyncScriptOnLoad}
                              required
                            />
                            {recaptchavalidate && (
                              <div className="ant-form-item-explain ant-form-item-explain-error">
                                <div role="alert">Please Checked Captcha!</div>
                              </div>
                            )}
                          </div>
                        </>
                      )}

                      <Form.Item>
                        <Button
                          type="default"
                          htmlType="submit"
                          block
                          style={{
                            backgroundColor: "#384e75",
                            borderRadius: "15px",
                          }}
                        >
                          Sign In
                        </Button>
                      </Form.Item>
                    </Form>
                    {/* <Alert message="User not valid !!" type="error" showIcon /> */}
                  </Card>
                </Col>
              </Row>
            </Col>

            {/* <Row
            style={{
              position: "absolute",
              bottom: "0px",
              textAlign: "center",
              width: "100%",
            }}
          >
            <Col span={19}></Col>
            <Col span={5}>
              <div className="login-footer-wrap">
                <span>©2021 Developed By I MARK TECHNOLOGY</span>
              </div>
            </Col>
          </Row> */}
          </div>
        </Modal>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { loggedIn, error } = state.authentication;
  return {
    loggedIn,
    error,
  };
}
const connectedLoginPage = connect(mapStateToProps)(LoginPage);
export { connectedLoginPage as LoginPage };
